import { Component, OnInit } from '@angular/core';
import { AuthservicesService } from 'src/app/services/authservices.service';

@Component({
  selector: 'app-payout-account',
  templateUrl: './payout-account.component.html',
  styleUrls: ['./payout-account.component.css']
})
export class PayoutAccountComponent implements OnInit {
   loading = false;

// 1. User has never connected Stripe
// stripeStatus = {
//   status: 'NOT_CONNECTED',
//   message: 'Connect your bank account to receive future payouts.'
// };

// 2. User started onboarding but didn't finish
// stripeStatus = {
//   status: 'INCOMPLETE',
//   message: 'Please complete your bank account setup.'
// };

// 3. Stripe requires more information
stripeStatus = {
  status: 'ACTION_REQUIRED',
  message: 'Additional information is required to verify your account.'
};

// 4. Stripe is reviewing the submitted information
// stripeStatus = {
//   status: 'UNDER_REVIEW',
//   message: 'Your verification is in progress. Stripe is reviewing your information.'
// };

// 5. Account is fully verified
// stripeStatus = {
//   status: 'ACTIVE',
//   message: 'Your bank account has been verified and is ready to receive payouts.'
// };
  constructor(
      private authService: AuthservicesService
  ) { }

  
  ngOnInit(): void {
    this.getStripeStatus();
  }
getStripeStatus() {

  this.loading = true;

  this.authService.getStripeStatus().subscribe(

    (res: any) => {

      this.loading = false;

      if (res.is_success) {
        this.stripeStatus = res.data;
      }

    },

    error => {

      this.loading = false;

      this.authService.successMessage(
        error.error.message,
        'error'
      );

    }

  );

}

 connectBankAccount() {

  this.loading = true;

  this.authService.connectStripeAccount().subscribe(

    (res: any) => {

      this.loading = false;

      if (res.is_success) {

        window.location.href = res.data.url;

      }

    },

    error => {

      this.loading = false;

      this.authService.successMessage(
        error.error.message,
        'error'
      );

    }

  );

}

  getButtonText(): string {

    switch (this.stripeStatus.status) {

      case 'NOT_CONNECTED':
        return 'Connect Bank Account';

      case 'INCOMPLETE':
        return 'Continue Setup';

      case 'ACTION_REQUIRED':
        return 'Complete Verification';

      case 'UNDER_REVIEW':
        return 'Verification in Progress';

      case 'ACTIVE':
        return 'Bank Account Connected';

      default:
        return 'Connect Bank Account';
    }
  }



}
